export default "__VITE_ASSET__X2wpoGQl__"